import type { ErrorCodes } from '../types/ErrorCodes';

type ErrorCodeInfo = {
    count: number;
    eventName?: string;
};

const encounteredErrorCodes = new Map<string, ErrorCodeInfo>();

export function addEncounteredErrorCode(errorCode: ErrorCodes, eventName?: string): void {
    const prefixedErrorCode = eventName ? `${eventName}_${errorCode}` : errorCode;

    const currentInfo = encounteredErrorCodes.get(prefixedErrorCode);
    if (currentInfo) {
        currentInfo.count++;
        if (eventName) {
            currentInfo.eventName = eventName;
        }
    } else {
        encounteredErrorCodes.set(prefixedErrorCode, { count: 1, eventName });
    }
}

export function getEncounteredErrorCodes() {
    return Object.fromEntries(encounteredErrorCodes.entries()) as {
        [code in ErrorCodes]: ErrorCodeInfo;
    };
}

export function haveEncounteredErrorCodes(): boolean {
    return encounteredErrorCodes.size > 0;
}
